import styled from 'styled-components';

export const MainHeaderWrapper = styled.div`
  position: relative;
  margin-bottom: 35px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-bottom: 45px;
  };
  ${props => props.theme.mediaQueries.phone}{
    padding: 0px;
  };
`;

export const MatchWidgetWrapper = styled.div`
  text-align: center;
  margin-top: -126px;
  z-index: 900;
  position: relative;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    top: 85px;
  };
`;

export const NextMatchWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  display: block;
  text-align: center;
  margin: auto;
  //box-shadow: 0 -11px 18px -4px rgba(0,0,0,0.3);
  border-bottom: 28px solid ${props => props.theme.colors.mainColor};
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  height: 0;
  border-radius: 13px 13px 5px 5px;
`;

export const DataMatchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 420px;
  margin: -3px auto 5px auto;
  border-top: 1px solid ${props => props.theme.colors.lightGray};
  padding-top: 5px;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin: auto;
    padding: 5px;
    justify-content: space-around;
    border: 1px solid ${props => props.theme.colors.lightGray};
  };
`;

export const DataMatchWrapperPoint = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    flex-direction: column;
  }
`;

export const HeaderShadow = styled.span`
    position: absolute;
    top: ${props => (props.isMobile ? '195px' : '137px')};
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
`;



// WEBPACK FOOTER //
// ./src/lib/components/MatchWidget/styles.js